<script setup>
import {ref, computed, onMounted} from 'vue';

/*
 * Replaces basic breadcrumbs. Should be applied only when Vue Router is taking place 
 */

const props = defineProps({
  /**
   * Ordered breadcrumbs to show in html format or object format
   * basic "a" tag will not work for Vue router. It will be replaced by router-link. Component will do it itself
   *
   * Examples:
   * Rechnungen
   * {href: '/EnPower/enloc-energy/EnVoice/', value: 'Rechnungen'}
   * {html: '<a href="/example"></a>'}
   */
  items: Array,
});

// Refs and Data
const breadcrumbs = ref(null);
const breadcrumbList = ref([]);

// Computed properties
/**
 * @computed {HTMLElement} breadcrumbWrapper - Gets the breadcrumb wrapper element.
 */
const breadcrumbWrapper = computed(() => {
  return document.getElementById('header-breadcrumb');
});

/**
 * @computed {Array} builtBreadcrumbs - Builds the list of breadcrumbs to be rendered.
 */
const builtBreadcrumbs = computed(() => {
  const breadcrumbsArray = [];

  breadcrumbList.value.forEach((breadcrumb) => {
    // if it is just a string, then it is the last of breadcrumbs and shouldn't be built as a link
    let breadcrumbToShow = typeof breadcrumb === 'object' ? breadcrumb : {value: breadcrumb};
    breadcrumbsArray.push(breadcrumbToShow);
  });
  // Move it to Navbar
  if (breadcrumbs.value && breadcrumbWrapper.value) {
    breadcrumbWrapper.value.replaceWith(breadcrumbs.value);
  }

  return breadcrumbsArray;
});

function isExternalUrl(url) {
  return url?.includes?.('http');
}

onMounted(() => {
  if (breadcrumbWrapper.value.children.length > 0) {
    // First element is a link to main page. Leave it without change
    breadcrumbList.value = [
      {html: breadcrumbWrapper.value.children[0].innerHTML},
      ...props.items,
    ];
  }
});
</script>

<template>
  <ul id="header-breadcrumb" ref="breadcrumbs">
    <li v-for="breadcrumb in builtBreadcrumbs">
      <!-- Vue doesn't support template with v-html. Any basic tag can work-->
      <span v-if="breadcrumb.html" v-html="breadcrumb.html"></span>
      <span v-else>
        <a v-if="isExternalUrl(breadcrumb.href)" :href="breadcrumb.href">{{ breadcrumb.value }}</a>
        <router-link :to="breadcrumb.href" v-else-if="breadcrumb.href">{{ breadcrumb.value }}</router-link>
        <template v-else>{{ breadcrumb.value }}</template>
      </span>
    </li>
  </ul>
</template>

<style scoped lang="scss">
</style>